export const RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
export const RESOURCE_TYPE_DEPLOYMENTS_PRECONDITION_RELAY =
	'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';
